import { useEffect, useState } from "react";
import { HeartHandshake, Clock, Check } from "lucide-react";
import { AdminLayout } from "@/components/AdminLayout";
import { ConsultingRequestButton } from "@/components/ConsultingRequestButton";
import { api } from "@/lib/api";
import { CONSULTING } from "@/constants/testIds";
import { toast } from "sonner";

export default function Consulting() {
  const [consultingRequests, setConsultingRequests] = useState([]);

  const loadConsultingRequests = () => {
    api.get("/consulting-requests").then(({ data }) => setConsultingRequests(data));
  };

  useEffect(loadConsultingRequests, []);

  const markConsultingResolved = async (id) => {
    try {
      await api.patch(`/consulting-requests/${id}`);
      loadConsultingRequests();
    } catch (err) {
      toast.error("No se pudo actualizar la solicitud");
    }
  };

  return (
    <AdminLayout>
      <div className="max-w-md">
        <h1 className="font-heading text-3xl font-bold text-charcoal tracking-tight flex items-center gap-3">
          <HeartHandshake className="w-7 h-7 text-petroleum" strokeWidth={1.5} /> Consultoría con un profesional de RH
        </h1>
        <p className="text-charcoal/60 mt-1 mb-6">
          ¿Necesitas orientación estratégica antes de tomar una decisión? Describe tu situación; un profesional de RH
          (persona real, no una IA) la revisa y te contacta por correo o teléfono para platicarte el costo y el
          tiempo estimado antes de cobrarte nada. Enviar tu solicitud no tiene costo.
        </p>

        <div className="bg-card border border-petroleum/10 rounded-xl p-5">
          <ConsultingRequestButton onSubmitted={loadConsultingRequests} />
        </div>

        {consultingRequests.length > 0 && (
          <div className="mt-6 space-y-2">
            <p className="text-sm font-semibold text-charcoal mb-2">Historial de solicitudes</p>
            {consultingRequests.map((r) => (
              <div key={r.id} data-testid={CONSULTING.historyRow} className="bg-card border border-petroleum/10 rounded-xl p-4">
                <div className="flex items-start justify-between gap-3">
                  <p className="text-sm text-charcoal/80 line-clamp-2">{r.context}{r.employee_name ? <span className="text-charcoal/50"> — sobre {r.employee_name}</span> : null}</p>
                  {r.status === "pending" ? (
                    <span className="flex items-center gap-1 text-xs font-medium text-amber-700 bg-amber-50 px-2.5 py-1 rounded-full shrink-0"><Clock className="w-3 h-3" /> Pendiente</span>
                  ) : (
                    <span className="flex items-center gap-1 text-xs font-medium text-emerald-700 bg-emerald-50 px-2.5 py-1 rounded-full shrink-0"><Check className="w-3 h-3" /> Atendida</span>
                  )}
                </div>
                {r.status === "pending" && (
                  <button data-testid={CONSULTING.markResolvedButton} onClick={() => markConsultingResolved(r.id)} className="text-xs font-medium text-petroleum underline mt-2">
                    Marcar como atendida
                  </button>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </AdminLayout>
  );
}
